import { Component, Input, ViewChild } from '@angular/core';
import {
	MatMenu,
	MatPopupTrigger,
	MenuPositionX,
	MenuPositionY,
	PopupPositionX,
	PopupPositionY,
} from '@lenovo/material/menu';

@Component({
	selector: 'vtr-ui-question-mark-button',
	templateUrl: './ui-question-mark-button.component.html',
	styleUrls: ['./ui-question-mark-button.component.scss'],
})
export class UiQuestionMarkButtonComponent {
	@Input() componentId: string;
	@Input() componentRole = 'img';
	@Input() tabIndex = 0;
	@Input() isGray = false;
	@Input() ariaLabel: string;
	@Input() tooltipText: string;
	@Input() xTooltipPosition: MenuPositionX | PopupPositionX = 'before';
	@Input() yTooltipPosition: MenuPositionY | PopupPositionY = 'center';
	@Input() tooltipReference: MatMenu;
	@Input() tooltipId: string;
	@Input() set tooltipCloseTrigger(shouldClose: boolean) {
		if (shouldClose && this.tooltipTrigger?.menuOpen) {
			this.tooltipTrigger.closeMenu();
		}
	}

	// Exposes the trigger api for the tooltip
	@ViewChild(MatPopupTrigger) tooltipTrigger: MatPopupTrigger;
}
